import axios from "axios";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const api = pythonVmInstance;

// Sales Order APIs
export const getStats = () => api.get("/api/stats");

export const getSalesOrderAlerts = () => api.get("/api/sales-order-alerts");

export const getSalesOrders = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.start_date) params.append("start_date", filters.start_date);
	if (filters.end_date) params.append("end_date", filters.end_date);
	if (filters.date_field) params.append("date_field", filters.date_field);
	if (filters.status) params.append("status", filters.status);
	if (filters.customer) params.append("customer", filters.customer);
	if (filters.site) params.append("site", filters.site);
	if (filters.style) params.append("style", filters.style);
	if (filters.channel) params.append("channel", filters.channel);
	if (filters.invoice_no) params.append("invoice_no", filters.invoice_no);
	if (filters.so_no) params.append("so_no", filters.so_no);
	if (filters.reference_site) params.append("reference_site", filters.reference_site);
	if (filters.color) params.append("color", filters.color);
	if (filters.created_by) params.append("created_by", filters.created_by);
	if (filters.brand) params.append("brand", filters.brand);
	if (filters.courier) params.append("courier", filters.courier);
	if (filters.division) params.append("division", filters.division);
	if (filters.seasons) params.append("seasons", filters.seasons);
	if (filters.courier_status) params.append("courier_status", filters.courier_status);
	if (filters.dispatch_breach) params.append("dispatch_breach", filters.dispatch_breach);
	if (filters.pickup_breach) params.append("pickup_breach", filters.pickup_breach);
	if (filters.delivery_breach) params.append("delivery_breach", filters.delivery_breach);
	if (filters.grc_breach) params.append("grc_breach", filters.grc_breach);
	if (filters.unverified_orders) params.append("unverified_orders", filters.unverified_orders);

	return api.get(`/api/sales-orders?${params.toString()}`);
};


export const downloadSalesOrderItemsExcel = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.start_date) params.append("start_date", filters.start_date);
	if (filters.end_date) params.append("end_date", filters.end_date);
	if (filters.status) params.append("status", filters.status);
	if (filters.customer) params.append("customer", filters.customer);
	if (filters.site) params.append("site", filters.site);
	if (filters.style) params.append("style", filters.style);
	if (filters.channel) params.append("channel", filters.channel);
	if (filters.invoice_no) params.append("invoice_no", filters.invoice_no);
	if (filters.so_no) params.append("so_no", filters.so_no);
	if (filters.reference_site) params.append("reference_site", filters.reference_site);
	if (filters.color) params.append("color", filters.color);
	if (filters.created_by) params.append("created_by", filters.created_by);
	if (filters.brand) params.append("brand", filters.brand);
	if (filters.courier) params.append("courier", filters.courier);
	if (filters.division) params.append("division", filters.division);
	if (filters.seasons) params.append("seasons", filters.seasons);
	if (filters.dispatch_breach) params.append("dispatch_breach", filters.dispatch_breach);
	if (filters.pickup_breach) params.append("pickup_breach", filters.pickup_breach);
	if (filters.delivery_breach) params.append("delivery_breach", filters.delivery_breach);
	if (filters.grc_breach) params.append("grc_breach", filters.grc_breach);

	return api.get(`/api/sales-orders/items/download?${params.toString()}`, {
		responseType: 'blob'
	});
};

export const downloadSalesOrderItemsCsv = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.start_date) params.append("start_date", filters.start_date);
	if (filters.end_date) params.append("end_date", filters.end_date);
	if (filters.status) params.append("status", filters.status);
	if (filters.customer) params.append("customer", filters.customer);
	if (filters.site) params.append("site", filters.site);
	if (filters.style) params.append("style", filters.style);
	if (filters.channel) params.append("channel", filters.channel);
	if (filters.invoice_no) params.append("invoice_no", filters.invoice_no);
	if (filters.so_no) params.append("so_no", filters.so_no);
	if (filters.reference_site) params.append("reference_site", filters.reference_site);
	if (filters.color) params.append("color", filters.color);
	if (filters.created_by) params.append("created_by", filters.created_by);
	if (filters.brand) params.append("brand", filters.brand);
	if (filters.courier) params.append("courier", filters.courier);
	if (filters.division) params.append("division", filters.division);
	if (filters.seasons) params.append("seasons", filters.seasons);
	if (filters.dispatch_breach) params.append("dispatch_breach", filters.dispatch_breach);
	if (filters.pickup_breach) params.append("pickup_breach", filters.pickup_breach);
	if (filters.delivery_breach) params.append("delivery_breach", filters.delivery_breach);
	if (filters.grc_breach) params.append("grc_breach", filters.grc_breach);

	return api.get(`/api/sales-orders/items/download-csv?${params.toString()}`, {
		responseType: 'blob'
	});
};

export const getSalesOrderFilterOptions = () => api.get('/api/sales-orders/filter-options');

export const getSalesOrderDetail = (soNo) => api.get(`/api/sales-orders/${soNo}`);


export const generatePodUrl = (podGcsUri) => api.post("/api/pod/generate-url", { podGcsUri });

export const getTatConfig = () => api.get("/api/config/tat");

// Return Order APIs
export const getReturnOrders = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.date_from) params.append("date_from", filters.date_from);
	if (filters.date_to) params.append("date_to", filters.date_to);
	if (filters.status) params.append("status", filters.status);
	if (filters.return_type) params.append("return_type", filters.return_type);

	return api.get(`/returns/unified?${params.toString()}`);
};

export const getReturnOrderFilterOptions = () => {
	return api.get("/returns/unified?filter_options=true");
};

export const downloadReturnOrders = (filters = {}) => {
	const params = new URLSearchParams();
	if (filters.date_from) params.append("date_from", filters.date_from);
	if (filters.date_to) params.append("date_to", filters.date_to);
	if (filters.status) params.append("status", filters.status);
	if (filters.return_type) params.append("return_type", filters.return_type);

	return api.get(`/returns/unified/download?${params.toString()}`, {
		responseType: 'blob'
	});
};

export default api;
